import {AssetLunarExchangeOptionDomain} from "../../domain/asset/AssetLunarExchangeOptionDomain"
import {AssetLunarExchangeOptionId} from "../../id/asset/AssetLunarExchangeOptionId"
import {UserId} from "../../id/user/UserId"
import {ValueObject} from "ts-protocol-extension"

/**
 * 루나 교환 옵션
 */
export class AssetLunarExchangeOptionValueObject implements ValueObject, AssetLunarExchangeOptionDomain {
    /**
     * 기본키
     */
    id: AssetLunarExchangeOptionId
    /**
     * 생성자 ID
     */
    creatorId: UserId
    /**
     * 지급 루나
     */
    lunarAmount: number
    /**
     * 소모 솔라
     */
    solarAmount: number
    /**
     * 생성일
     */
    createdAt: Date
    /**
     * 마지막 수정일
     */
    lastModifiedAt?: Date

    constructor(o: Record<keyof AssetLunarExchangeOptionDomain, any>) {
        this.id = BigInt(o.id)
        this.creatorId = BigInt(o.creatorId)
        this.lunarAmount = Number(o.lunarAmount)
        this.solarAmount = Number(o.solarAmount)
        this.createdAt = new Date(o.createdAt)
        if (o.lastModifiedAt !== undefined && o.lastModifiedAt !== null) {
            this.lastModifiedAt = new Date(o.lastModifiedAt)
        }
    }
}
